export enum RouteAction {
  ROUTE_UPDATE = "ROUTE_UPDATE",
  ROUTE_REFRESH = "ROUTE_REFRESH",
}
